import { useSelector } from '@xstate/store-react';
import { store } from '../store';

export const useUrlParams = () => useSelector(store, (state) => state.context.urlParams);
